import { createAsyncThunk } from "@reduxjs/toolkit";
import { checkVerifyCode, sendVerifyCode } from "libs/api/verify";

// ** Check Verify Code Thunk **
export const checkVerifyCodeThunk = createAsyncThunk(
  "verify/code/check",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
    body,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await checkVerifyCode(pathname, queryParams, body);
      typeof cbFulfilled === "function" && cbFulfilled(response?.data);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// ** Send Verify Code Thunk**
export const sendVerifyCodeThunk = createAsyncThunk(
  "verify/code/send",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
    body,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await sendVerifyCode(pathname, queryParams, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);